import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

const SPECIAL_CATEGORIES = {
  chuzhbina: { name: "Чужбина", slug: "chuzhbina", description: "Новини и анализи от Германия, Швейцария и останала Европа" },
};

export default function CategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [articles, setArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setPage(1);
    if (SPECIAL_CATEGORIES[slug]) {
      setCategory(SPECIAL_CATEGORIES[slug]);
    } else {
      api.get("/categories").then(({ data }) => setCategory(data.find((c) => c.slug === slug)));
    }
  }, [slug]);

  useEffect(() => {
    api.get("/articles", { params: { category: slug, page, limit: 12 } }).then(({ data }) => {
      setArticles(data.items);
      setTotal(data.total);
    });
  }, [slug, page]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="category-page">
      <SEO title={category?.name || "Категория"} description={category?.description || `Статии в категория ${category?.name || ""}`} />
      <div className="text-xs text-[#66717B] mb-3">
        <a href="/" className="hover:text-[#C47A35]">Начало</a>
        <span className="mx-2">/</span>
        <span className="text-[#C47A35] font-semibold uppercase tracking-wide">{category?.name}</span>
      </div>
      <h1 className="font-serif text-4xl font-bold text-[#10243A] mb-10 pb-4 border-b-2 border-[#10243A] inline-block" data-testid="category-title">
        {category?.name}
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="category-articles-grid">
        {articles.map((a) => <ArticleCard key={a.id} article={a} variant="grid" />)}
      </div>
      {articles.length === 0 && <p className="text-[#66717B] mt-6">Все още няма статии в тази категория.</p>}
      {total > 12 && (
        <div className="flex justify-center gap-3 mt-10">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="px-4 py-2 border border-[#E4E7E9] disabled:opacity-40 hover:border-[#10243A] transition-colors" data-testid="pagination-prev">Назад</button>
          <button disabled={page * 12 >= total} onClick={() => setPage((p) => p + 1)} className="px-4 py-2 border border-[#E4E7E9] disabled:opacity-40 hover:border-[#10243A] transition-colors" data-testid="pagination-next">Напред</button>
        </div>
      )}
    </div>
  );
}
